<template>
  <router-view></router-view>
  <!-- <HUBLoader v-if="pageLoading" /> -->
  <!-- <div class="debug">
    <div>currentFunction: {{ SessionStore.HUBSettings.currentFunction }}</div>
    <div>levelUp: {{ SessionStore.HUBSettings.levelUp }}</div>
    <div>currentLearningType: {{ SessionStore.HUBSettings.currentLearningType.name }}</div>
    <div>currentTheme: {{ SessionStore.HUBSettings.currentTheme.name }}</div>
    <div>currentClient: {{ SessionStore.HUBSettings.currentClient.code }}</div>
  </div> -->
</template>

<script setup>
import useLanguageStore from '@/stores/language';
import useSessionStore from '@/stores/session';
import Logger from '@/utils/logger';

// Load local stored session token
const SessionStore = useSessionStore();
const storedToken = localStorage.getItem('hub-facilitator-portal-token');
SessionStore.setToken(storedToken === 'null' ? null : storedToken);

// Load local stored language
const LanguageStore = useLanguageStore();
const storedLanguage = localStorage.getItem('hub-facilitator-portal-locale');
LanguageStore.setLocale(storedLanguage === 'null' ? null : storedLanguage);

window.addEventListener('online', () => {
  Logger.debug(`navigator.onLine: ${navigator.onLine}`);
  Logger.debug('I am connected to the internet');
});

window.addEventListener('offline', () => {
  Logger.debug(`navigator.onLine: ${navigator.onLine}`);
  Logger.debug('Disconnected...so sad!!!');
});
</script>

<style scoped>
@import url('@/assets/styles/main.css');

.debug {
  position: fixed;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 300px;
  box-sizing: border-box;
  padding: 10px;
  background-color: #333;
  justify-content: center;
  /* align-items: center; */
  color: white;
  opacity: 0.9;
}
.debug > div {
  padding: 5px 0;
}
</style>
